import axiosInstance from "../instance/AxiosInstance";
export const serviceViewEffect = async (payload) => {
  try {
    const response = await axiosInstance.get(
      `/services/getservice?service_id=${payload}`
    );
    return response;
  } catch (error) {
    throw error.response?.data?.message || "Failed to Fetch Service";
  }
};
export const serviceViewAllEffect = async (payload) => {
  try {
    const response = await axiosInstance.get(
      `/services/list?pageNo=${payload.pageNo}&pagesize=${payload.pagesize}&pagination_required=true`
    );

    return response.data;
  } catch (error) {
    throw error.response?.data?.message || "Failed to Fetch Services";
  }
};
export const fetchAllServiceEffect = async () => {
  try {
    const response = await axiosInstance.get(`/services/list`);
    // console.log('response', response);
    return response.data;
  } catch (error) {
    throw error.response?.data?.message || "Failed to Fetch Services";
  }
};

export const serviceAddEffect = async (payload) => {
  try {
    const response = await axiosInstance.post(
      "/services/insertservice",
      payload
    );
    console.log("SERVICE_ADD_SUCCESS payload:", response);
    return response.data;
  } catch (error) {
    throw error || "Failed to Add Service";
  }
};
export const serviceUpdateEffect = async (payload) => {
  try {
    const response = await axiosInstance.put(
      `/services/updateService/${payload.id}`,
      payload
    );
    return response.data;
  } catch (error) {
    throw error.response?.data?.message || "Failed to Updata Service";
  }
};
export const serviceDeleteEffect = async (payload) => {
  try {
    const response = await axiosInstance.delete(
      `/services/deleteservice/${payload}`
    );
    return response.data;
  } catch (error) {
    throw error.response?.data?.message || "Failed to Delete Service";
  }
};
export const serviceApprovalEffect = async ({ serviceId, status }) => {
  try {
    const response = await axiosInstance.put(`/services/approve/${serviceId}`, {
      approval_status: status,
    });
    return response.data;
  } catch (error) {
    throw error.response?.data?.message || "Failed to update approval status";
  }
};
